const parseTechString = (str: string, tech: string) => [
  str.slice(0, str.indexOf(tech)),
  str.slice(str.indexOf(tech) + tech.length)
];
export const generateConfidentPhrase = (tech: string) => {
  const phrases = [
    `${tech} accelerators`,
    `${tech} architects`,
    `${tech} automators`,
    `${tech} big shots`,
    `${tech} brokers`,
    `${tech} catalysts`,
    `${tech} champions`,
    `${tech} conquerors`,
    `${tech} creators`,
    `${tech} designers`,
    `${tech} developers`,
    `${tech} digital gurus`,
    `${tech} digital pioneers`,
    `${tech} disruptors`,
    `${tech} drivers`,
    `${tech} elitists`,
    `${tech} engineers`,
    `${tech} entrepreneurs`,
    `${tech} excellence`,
    `${tech} experts`,
    `${tech} explorers`,
    `${tech} facilitators`,
    `${tech} forerunners`,
    `${tech} fortune builders`,
    `${tech} game-changers`,
    `${tech} geniuses`,
    `${tech} ground-breakers`,
    `${tech} growth hackers`,
    `${tech} innovators`,
    `${tech} leaders`,
    `${tech} luminaries`,
    `${tech} maestros`,
    `${tech} magicians`,
    `${tech} magnates`,
    `${tech} masters`,
    `${tech} millionaire makers`,
    `${tech} miracle makers`,
    `${tech} moguls`,
    `${tech} optimizers`,
    `${tech} perfectionists`,
    `${tech} pioneers`,
    `${tech} rainmakers`,
    `${tech} revolutionaries`,
    `${tech} savants`,
    `${tech} scientists`,
    `${tech} sharks`,
    `${tech} specialists`,
    `${tech} tech geniuses`,
    `${tech} titans`,
    `${tech} trailblazers`,
    `${tech} transformers`,
    `${tech} trend-setters`,
    `${tech} tycoons`,
    `${tech} visionaries`,
    `${tech} winners`,
    `${tech} wizards`,
    `${tech}, brought to you by BAM`,
    `${tech}, fueled by BAM`,
    `${tech}, powered by BAM`,
    `${tech}, solved by BAM`,
    `BAM builds ${tech} better`,
    `BAM builds ${tech} faster`,
    `BAM builds ${tech} smarter`,
    `Elite ${tech}`,
    `Experts in ${tech}`,
    `High-performance ${tech}`,
    `Next-level ${tech}`,
    `Peak-performance ${tech}`,
    `Precision ${tech}`,
    `The ${tech} agency`,
    `The ${tech} people`,
    `Undefeated ${tech} champions`,
    `Undisputed ${tech} champions`,
    `We automate ${tech}`,
    `We connect ${tech}`,
    `We conquer ${tech}`,
    `We materialize ${tech}`
  ];
  const [start, end] = parseTechString(
    phrases[Math.floor(Math.random() * phrases.length)],
    tech
  );
  const colors = ["green", "purple", "teal", "blueFrost", "errorRed", "yellow"];

  return (
    <span className="phrase">
      {start}
      <span
        className={`phrase-color ${
          colors[Math.floor(Math.random() * colors.length)]
        }`}
      >
        {tech}
      </span>
      {end}
    </span>
  );
};
